import { GalleryComponent } from '../../../models/LessonComponent';
import { GalleryEditor } from './GalleryEditor';
import { GalleryView } from './GalleryView';
import React from 'react';
import { useLessonContext } from '../../../models/LessonContext';
import useThemes from '../../../../shared/hooks/useThemes';

export interface GalleryProps {
  component: GalleryComponent;
}

export const Gallery = (props: GalleryProps) => {
  const { mode } = useLessonContext();
  const { muiTheme } = useThemes();
  const fontFamily = muiTheme.typography.fontFamily;

  return (
    <div style={{ fontFamily, overflowWrap: 'anywhere' }}>
      {mode === 'edit' ? (
        <GalleryEditor {...props} />
      ) : (
        <GalleryView {...props} />
      )}
    </div>
  );
};
